import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, ShoppingCart, Star } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { useBookDetail } from '../hooks/useCatalog';
import '../styles/detail.css';

const BookDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addItem, formatPrice } = useCart();
  const { book, related, loading } = useBookDetail(id);

  if (loading) {
    return (
      <div className="detail-page">
        <div className="detail-skeleton" />
      </div>
    );
  }

  if (!book) {
    return (
      <div className="detail-page">
        <div className="detail-empty">
          <h2>Libro no encontrado</h2>
          <button type="button" onClick={() => navigate('/books')}>Volver al catalogo</button>
        </div>
      </div>
    );
  }

  return (
    <div className="detail-page">
      <button type="button" className="detail-back" onClick={() => navigate(-1)}>
        <ArrowLeft size={16} />
        Volver
      </button>

      <section className="detail-layout">
        <motion.div className="detail-cover" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <img src={book.coverUrl} alt={book.title} />
        </motion.div>

        <motion.article className="detail-content" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}>
          <span className="detail-chip">{book.category}</span>
          <h1>{book.title}</h1>
          <p className="detail-author">por {book.author}</p>

          <div className="detail-rating">
            <Star size={16} />
            <span>{book.rating.toFixed(1)} / 5</span>
          </div>

          <p className="detail-description">{book.description}</p>

          <div className="detail-meta">
            <span>Idioma: {book.language}</span>
            <span>Formato: {book.format}</span>
            <span>Stock: {book.stock}</span>
          </div>

          <div className="detail-price">{formatPrice(book.price)}</div>

          <button type="button" className="detail-primary" onClick={() => addItem(book)}>
            <ShoppingCart size={18} />
            Agregar al carrito
          </button>
        </motion.article>
      </section>

      <section className="detail-related">
        <h2>Libros relacionados</h2>
        <div className="detail-related__grid">
          {related.map((item) => (
            <article key={item.id} className="related-card">
              <img src={item.coverUrl} alt={item.title} />
              <h3>{item.title}</h3>
              <p>{item.author}</p>
              <div>
                <button type="button" onClick={() => navigate(`/libro/${item.id}`)}>Ver detalles</button>
                <button type="button" onClick={() => addItem(item)}>Agregar</button>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default BookDetailPage;
